import {
  mapAnalyticsJoinRole,
  trackRoomCreated,
  trackRoomJoined,
} from "../../../services/analytics/bridges/roomAnalytics";
import { trackInviteJoinCompleted } from "../../../services/analytics/bridges/inviteAnalytics";
import { trackFailedRoomJoin } from "../service/analyticsService";

/**
 * Canonical room_created (replaces legacy match_created).
 * @param {'referee'|'spectator'} _role
 * @param {{ hasViewCode?: boolean; creatorPlaysInSession?: boolean; roomLabelPresent?: boolean }} [ctx]
 */
export function reportMatchCreated(_role, ctx = {}) {
  trackRoomCreated({
    creatorPlays: ctx.creatorPlaysInSession !== false,
    isPrivate: Boolean(ctx.hasViewCode),
    roomLabelPresent: ctx.roomLabelPresent !== false,
  });
}

/**
 * Canonical room_joined (replaces legacy match_joined).
 * @param {'referee'|'spectator'|string} role
 * @param {{
 *   hasViewCode?: boolean;
 *   resume?: boolean;
 *   registerAsCreator?: boolean;
 *   isDeputy?: boolean;
 *   joinSource?: 'code'|'link'|'qr'|'resume';
 * }} [ctx]
 */
export function reportMatchJoined(role, ctx = {}) {
  const joinSource = ctx.resume
    ? "resume"
    : ctx.joinSource || (ctx.hasViewCode ? "link" : "code");

  trackRoomJoined({
    joinRole: mapAnalyticsJoinRole(role, ctx),
    joinSource,
  });
}

/**
 * Canonical invite_join_completed (roster / spectator invite landings only).
 * @param {'referee'|'spectator'|string} role
 * @param {{
 *   registerAsCreator?: boolean;
 *   isDeputy?: boolean;
 *   rosterInvite?: boolean;
 *   spectatorInvite?: boolean;
 * }} [ctx]
 */
export function reportInviteJoinCompleted(role, ctx = {}) {
  const inviteChannel = ctx.rosterInvite
    ? "roster"
    : ctx.spectatorInvite
      ? "spectator"
      : null;
  if (!inviteChannel) return;
  trackInviteJoinCompleted({
    inviteChannel,
    joinRole: mapAnalyticsJoinRole(role, ctx),
  });
}

/**
 * @param {string} reason
 */
export function reportFailedRoomJoin(reason) {
  const safe =
    reason === "not_found"
      ? "not_found"
      : reason === "wrong_code"
        ? "wrong_code"
        : reason === "auth_required"
          ? "auth_required"
          : reason === "rules"
            ? "permission_denied"
            : "unknown";
  if (safe === "permission_denied") {
    trackFailedRoomJoin({ error_kind: "permission_denied", reason: safe });
  } else {
    trackFailedRoomJoin({ error_kind: "join_failed", reason: safe });
  }
}
